import { Typography, Stack, Card, CardContent, Divider } from '@mui/material';
import { t } from 'i18next'
import BillingSubscriptionsItemsTable from "./BillingSubscriptionsItemsTable";
import { isEmpty } from 'lodash';

type BillingSubscriptionsProps = {
    subscriptions: any;
    subscriptionSchedules: any;
}

function BillingSubscriptions({ subscriptions, subscriptionSchedules }: BillingSubscriptionsProps) {


    return (
        <Card >
            <CardContent>
                <div className="fixed-width">
                    <Stack spacing={2}>
                        <Typography variant="h5" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                            {t("billing:subscriptions")}
                        </Typography>
                        <Divider />
                        <BillingSubscriptionsItemsTable subscriptions={subscriptions} subscriptionSchedules={subscriptionSchedules} ></BillingSubscriptionsItemsTable>
                    </Stack>
                </div>

            </CardContent>
        </Card>
    );
}

export default BillingSubscriptions;
